import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  LocationOnOutlined,
  LocalShippingOutlined,
  CalendarTodayOutlined,
  DescriptionOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetRealTimeTrackingDetailQuery } from "store/services/realTimeTrackingApi";

const RealTimeTrackingInfoScreen = ({ trackingId }) => {
  const breadcrumbs = [
    {
      title: "Real-Time Tracking Info",
    },
  ];

  // RTK Query
  const {
    data: trackingDetail,
    isLoading: loadingTrackingDetail,
    error,
  } = useGetRealTimeTrackingDetailQuery(trackingId);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingTrackingDetail}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingTrackingDetail ? (
          <Box padding={3}>
            <Typography variant="h6">Real-Time Tracking Details</Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DescriptionOutlined color="primary" />}
                  title="Tracking ID"
                  subtitle={trackingDetail?.trackingId || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalShippingOutlined color="primary" />}
                  title="Vehicle ID"
                  subtitle={trackingDetail?.vehicle_id?.registration || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocationOnOutlined color="primary" />}
                  title="Location"
                  subtitle={
                    trackingDetail?.location
                      ? `Lat: ${trackingDetail.location.lat}, Lon: ${trackingDetail.location.lon}`
                      : "Unknown"
                  }
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Timestamp"
                  subtitle={
                    new Date(trackingDetail?.timestamp).toLocaleString() ||
                    "N/A"
                  }
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => (
                    <Status
                      isActive={trackingDetail?.status === "On The Way"}
                    />
                  )}
                  title="Status"
                  subtitle={trackingDetail?.status || "Unknown"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DescriptionOutlined color="primary" />}
                  title="Entity"
                  subtitle={trackingDetail?.entity?.name || "N/A"}
                />
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default RealTimeTrackingInfoScreen;
